import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=7ff8a5fc"
import script from "./advert.vue?vue&type=script&lang=js"
export * from "./advert.vue?vue&type=script&lang=js"
import style0 from "./advert.vue?vue&type=style&index=0&id=7ff8a5fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports